<template>
  <v-row class>
    <GlobalNavMobile v-if="isAllowed()" />
    <NotificationDrawer />
    <router-view></router-view>
  </v-row>
</template>

<script>
import NotificationDrawer from '@/components/Notifications/NotificationDrawer';
import GlobalNavMobile from './GlobalNavMobile';
import { initFreshworksWidget, toggleFreshworksWidget } from '@/FreshWorks';
export default {
  components: {
    NotificationDrawer,
    GlobalNavMobile
  },
  data() {
    return {};
  },
  props: {
    isSSOWindow: Boolean
  },
  watch: {
    $route() {
      this.validatePageForFreshworksWidget();
    }
  },
  mounted() {
    this.loadFreshworksWidget();
  },
  methods: {
    // To load freshworks widget by checking for can_use_fresh_chat permission
    loadFreshworksWidget() {
      if (this.$can('use', 'fresh_chat')) {
        initFreshworksWidget(document);

        this.validatePageForFreshworksWidget();
      }
    },
    /**
     * Function to check current page to show/hide FreshworksWidget
     * Hide for pages:- for SSO window
     */
    validatePageForFreshworksWidget() {
      if (window.FreshworksWidget) {
        toggleFreshworksWidget(!this.isSSOWindow);
      }
    }
  }
};
</script>

<style>
#freshworks-container #launcher-frame {
  max-width: 104px !important;
}
</style>
